module.exports = __webpack_public_path__ + "static/media/LABRA_Ai.75e1b4a7.png";